import Head from "next/head";
import { FC } from "react";
import { toAbsoluteUrl } from "src/utils/seo";

function addItemArrayByCamma(arr: string[] | []) {
  let result = "";
  for (let i = 0; i < arr.length; i++) {
    result += `${arr[i]}${arr.length - 1 === i ? "" : ","}`;
  }
  return result;
}

type Props = {
  title?: string;
  description?: string;
  featuredImage?: string;
  date: string;
  keyword?: string[] | [];
  commentCount?: string;
  seoDescription?: string;
  price?: string | number;
  isScript?: boolean;
  canonical: string;
};

const Schema: FC<Props> = ({
  title,
  description,
  featuredImage,
  date,
  keyword,
  commentCount,
  seoDescription,
  price,
  canonical,
  isScript = true,
}) => {
  return (
    <Head>
      <meta
        name="keywords"
        content={addItemArrayByCamma(keyword ?? []) || "اموزش, دادبانان, دوره"}
      />
      {isScript && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: `{
            "@context": "https://schema.org",
            "@type": "Product",
            "image": "${
              featuredImage ?? "https://dadbanan.com/images/logo-white.png"
            }",
            "name": "${(title as string)?.replace(/"/g, " ")}",
            "description": "${
              (description as string)?.replace(/"/g, " ") ?? ""
            }",
            "offers": {
              "@type": "Offer",
              "url": "${toAbsoluteUrl(canonical)}",
              "price": "${price}",
              "priceCurrency": "IRR"
            }
          }
            `,
          }}
        />
      )}
    </Head>
  );
};
export default Schema;
